<template>
  <div>
    <v-layout row align-center>
      <v-menu
        nudge-bottom="30"
        class="pr-4 pb-1"
        open-on-hover
        bottom
        right
        max-width="300"
      >
        <div slot="activator">
          <span class="subheading text-vertical-middle">Academic average</span>
          <v-icon class="" color="muted" right>mdi-help-circle</v-icon>
        </div>
        <v-card dark>
          <v-card-text>
            Please provide your most recent <strong>overall</strong>
            academic aggregate/average results for this qualification.
          </v-card-text>
        </v-card>
      </v-menu>
      <v-slider
        v-if="model.gradeScale === 'Percentage'"
        v-model="model.gradeValue"
        :min="0"
        :max="100"
        thumb-label
        @input="update"
        :color="color"
        :disabled="disabled"
        always-dirty
      />
      <v-slider
        v-if="
          [
            '4-point GPA',
            'Liberian 4-point GPA',
            'Nigerian 4-point GPA',
          ].indexOf(model.gradeScale) >= 0
        "
        v-model="model.gradeValue"
        :min="0"
        :max="4"
        :step="0.01"
        thumb-label
        @input="update"
        :color="color"
        :disabled="disabled"
        always-dirty
      />
      <v-slider
        v-if="
          [
            '5-point GPA',
            'Nigerian 5-point GPA',
            'Ugandan 5-point GPA',
          ].indexOf(model.gradeScale) >= 0
        "
        v-model="model.gradeValue"
        :min="0"
        :max="5"
        :step="0.01"
        thumb-label
        @input="update"
        :color="color"
        :disabled="disabled"
        always-dirty
      />
      <v-slider
        v-if="model.gradeScale === '6-point GPA'"
        v-model="model.gradeValue"
        :min="0"
        :max="6"
        :step="0.01"
        thumb-label
        @input="update"
        :color="color"
        :disabled="disabled"
        always-dirty
      />
      <v-slider
        v-if="model.gradeScale === '7-point GPA'"
        v-model="model.gradeValue"
        :min="0"
        :max="7"
        :step="0.01"
        thumb-label
        @input="update"
        :color="color"
        :disabled="disabled"
        always-dirty
      />
      <v-slider
        v-if="model.gradeScale === 'Benin 20-point GPA'"
        v-model="model.gradeValue"
        :min="0"
        :max="20"
        :step="0.01"
        thumb-label
        @input="update"
        :color="color"
        :disabled="disabled"
        always-dirty
      />
      <v-slider
        v-if="model.gradeScale === 'International Baccalaureate Point Grade'"
        v-model="model.gradeValue"
        :min="1"
        :max="7"
        :step="1"
        thumb-label
        @input="update"
        :color="color"
        :disabled="disabled"
        always-dirty
      />
      <v-slider
        v-if="model.gradeScale === 'Cambridge Number Grade'"
        v-model="gradeValue"
        :disabled="disabled"
        @input="update"
        :color="color"
        :max="gradeValues[model.gradeScale].length - 1"
        :min="0"
      />
      <v-slider
        v-if="
          [
            'Botswana Class Grade',
            'British Class Grade',
            'Kenyan Class Grade',
            'Zimbabwe Class Grade',
          ].indexOf(model.gradeScale) >= 0
        "
        v-model="gradeValue"
        :tick-labels="['Fail', '3rd', '2nd Lower', '2nd Upper', '1st']"
        :disabled="disabled"
        @input="update"
        :color="color"
        ticks
        :max="gradeValues[model.gradeScale].length - 1"
        :min="0"
      />
      <v-slider
        v-if="model.gradeScale === 'Ugandan UACE Points Grade'"
        v-model="model.gradeValue"
        :min="0"
        :max="20"
        :step="1"
        thumb-label
        @input="update"
        :color="color"
        :disabled="disabled"
        always-dirty
      />
      <v-slider
        v-if="model.gradeScale === 'Botswana GCSE Points Grade'"
        v-model="model.gradeValue"
        :min="0"
        :max="48"
        :step="1"
        thumb-label
        @input="update"
        :color="color"
        :disabled="disabled"
        always-dirty
      />
      <v-slider
        v-if="model.gradeScale === 'Botswana GCSE Letter Grade'"
        v-model="gradeValue"
        :disabled="disabled"
        @input="update"
        :color="color"
        :max="gradeValues[model.gradeScale].length - 1"
        :min="0"
      />
      <v-slider
        v-if="model.gradeScale === 'Cameroon Letter Grade'"
        v-model="gradeValue"
        :disabled="disabled"
        @input="update"
        :color="color"
        :max="gradeValues[model.gradeScale].length - 1"
        :min="0"
      />
      <v-slider
        v-if="model.gradeScale === 'Cameroon Point Grade'"
        v-model="model.gradeValue"
        :disabled="disabled"
        @input="update"
        :color="color"
        :min="0"
        :max="20"
        :step="0.1"
      />
      <v-slider
        v-if="model.gradeScale === 'KCSE Letter Grade'"
        v-model="gradeValue"
        :disabled="disabled"
        @input="update"
        :color="color"
        :max="gradeValues[model.gradeScale].length - 1"
        :min="0"
      />
      <v-slider
        v-if="model.gradeScale === 'Kenyan Letter Grade'"
        v-model="gradeValue"
        :disabled="disabled"
        @input="update"
        :color="color"
        :max="gradeValues[model.gradeScale].length - 1"
        :min="0"
      />
      <v-slider
        v-if="model.gradeScale === 'WAEC Grading'"
        v-model="gradeValue"
        :disabled="disabled"
        @input="update"
        :color="color"
        :max="gradeValues[model.gradeScale].length - 1"
        :min="0"
      />
      <v-slider
        v-if="model.gradeScale === 'Zambian Points Grading'"
        v-model="gradeValue"
        :disabled="disabled"
        @input="update"
        :color="color"
        :max="gradeValues[model.gradeScale].length - 1"
        :min="0"
      />
      <v-slider
        v-if="model.gradeScale === 'A-Level Letter Grade'"
        v-model="gradeValue"
        :disabled="disabled"
        @input="update"
        :color="color"
        :max="gradeValues[model.gradeScale].length - 1"
        :min="0"
      />
      <v-slider
        v-if="model.gradeScale === 'O-Level Letter Grade'"
        v-model="gradeValue"
        :disabled="disabled"
        @input="update"
        :color="color"
        :max="gradeValues[model.gradeScale].length - 1"
        :min="0"
      />
    </v-layout>

    <v-layout
      row
      align-center
      v-if="gradeValue || model.gradeValue"
      class="mb-2"
    >
      <v-icon class="ma-2" color="warning" right>mdi-alert</v-icon>
      <div>
        Double-check your grade, as misrepresenting your qualification is a
        criminal offence in certain jurisdictions.
      </div>
    </v-layout>

    <v-layout row align-center>
      <div class="pr-3">
        <v-avatar size="60" color="primary">
          <v-avatar size="56" color="white">
            <span class="title">
              {{ model.gradeValue ? model.gradeValue : 0 }}
            </span>
          </v-avatar>
        </v-avatar>
      </div>
      <!-- z-index 300 to cater for safari bug -->
      <v-select
        label="Academic Grading Scale"
        v-model="model.gradeScale"
        :items="scales"
        @input="update"
        clearable
        :color="color"
        :dark="dark"
        :style="toFront ? 'z-index: 300' : ''"
        :disabled="disabled"
        :attach="attach"
      />
    </v-layout>
  </div>
</template>

<script>
// Helpers
import _ from "lodash";
import { mapGetter } from "vuex";

// Data
import gradeScales from "@/data/grade_scales";

// Vue Component
export default {
  created() {
    if (!this.model.gradeScale) {
      this.model.gradeScale =
        _.get(this.value, "institution.grade_scale") || "Percentage";
    }
  },
  props: {
    // Grade information
    value: Object,
    scales: { type: Array, default: () => gradeScales },
    // Styling
    color: { type: String, default: () => "deep-orange" },
    dark: Boolean,
    disabled: Boolean,
    toFront: { type: Boolean, default: () => true },
    attach: { type: Boolean, default: () => false },
  },
  data() {
    return {
      gradeValues: {
        "A-Level Letter Grade": ["F", "O", "E", "D", "C", "B", "A"],
        "O-Level Letter Grade": ["U", "E", "D", "C", "B", "A"],
        "Botswana Class Grade": ["F", "3", "2.2", "2.1", "1"],
        "Botswana GCSE Letter Grade": [
          "U",
          "G",
          "F",
          "E",
          "D",
          "C",
          "B",
          "A",
          "A*",
        ],
        "British Class Grade": ["F", "3", "2.2", "2.1", "1"],
        "Cambridge Number Grade": ["U", "4", "3", "2", "1"],
        "Cameroon Letter Grade": ["F", "D", "D+", "C", "C+", "B", "B+", "A"],
        "KCSE Letter Grade": [
          "F",
          "D-",
          "D",
          "D+",
          "C-",
          "C",
          "C+",
          "B-",
          "B",
          "B+",
          "A-",
          "A",
        ],
        "Kenyan Class Grade": ["F", "3", "2.2", "2.1", "1"],
        "Kenyan Letter Grade": ["F", "D", "C", "B", "A"],
        "WAEC Grading": ["F9", "E8", "D7", "C6", "C5", "C4", "B3", "B2", "A1"],
        "Zambian Points Grading": [
          "Fail",
          "Pass",
          "Credit",
          "Merit",
          "Distinction",
        ],
        "Zimbabwe Class Grade": ["F", "3", "2.2", "2.1", "1"],
      },
      gradeValue: 0,
      // Model
      model: {
        gradeScale: this.value.gradeScale,
        gradeValue: this.value.gradeValue,
      },
    };
  },
  methods: {
    update() {
      if (!this.model.gradeScale) {
        this.model.gradeValue = null;
      }
      if (this.model.gradeScale === "A-Level Letter Grade") {
        this.model.gradeValue =
          this.gradeValues["A-Level Letter Grade"][this.gradeValue];
      }
      if (this.model.gradeScale === "O-Level Letter Grade") {
        this.model.gradeValue =
          this.gradeValues["O-Level Letter Grade"][this.gradeValue];
      }
      if (this.model.gradeScale === "Botswana Class Grade") {
        this.model.gradeValue =
          this.gradeValues["Botswana Class Grade"][this.gradeValue];
      }
      if (this.model.gradeScale === "Botswana GCSE Letter Grade") {
        this.model.gradeValue =
          this.gradeValues["Botswana GCSE Letter Grade"][this.gradeValue];
      }
      if (this.model.gradeScale === "British Class Grade") {
        this.model.gradeValue =
          this.gradeValues["British Class Grade"][this.gradeValue];
      }
      if (this.model.gradeScale === "Zimbabwe Class Grade") {
        this.model.gradeValue =
          this.gradeValues["Zimbabwe Class Grade"][this.gradeValue];
      }
      if (this.model.gradeScale === "Cambridge Number Grade") {
        this.model.gradeValue =
          this.gradeValues["Cambridge Number Grade"][this.gradeValue];
      }
      if (this.model.gradeScale === "Cameroon Letter Grade") {
        this.model.gradeValue =
          this.gradeValues["Cameroon Letter Grade"][this.gradeValue];
      }
      if (this.model.gradeScale === "KCSE Letter Grade") {
        this.model.gradeValue =
          this.gradeValues["KCSE Letter Grade"][this.gradeValue];
      }
      if (this.model.gradeScale === "Kenyan Class Grade") {
        this.model.gradeValue =
          this.gradeValues["Kenyan Class Grade"][this.gradeValue];
      }
      if (this.model.gradeScale === "Kenyan Letter Grade") {
        this.model.gradeValue =
          this.gradeValues["Kenyan Letter Grade"][this.gradeValue];
      }
      if (this.model.gradeScale === "WAEC Grading") {
        this.model.gradeValue =
          this.gradeValues["WAEC Grading"][this.gradeValue];
      }
      if (this.model.gradeScale === "Zambian Points Grading") {
        this.model.gradeValue =
          this.gradeValues["Zambian Points Grading"][this.gradeValue];
      }

      this.$emit("input", this.model);
    },
  },
};
</script>
